import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Layout, Menu, Button, Typography, Table, Space, message } from 'antd';
import { UserOutlined, LogoutOutlined, PlusOutlined } from '@ant-design/icons';
import DashboardLayout from './DashboardLayout';
import DomainList from './DomainList';
import DomainRegistration from './DomainRegistration';

const { Content } = Layout;
const { Title } = Typography;

const Dashboard = React.memo(() => {
  const { user, signOut } = useAuth();
  return (
    <DashboardLayout>
      <Content className="p-8">
        <div className="max-w-6xl mx-auto">
          <DomainRegistration />
        </div>
      </Content>
    </DashboardLayout>
  );
});

export default Dashboard;